var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2507 26.25H22.7507V29.75H19.2507V26.25ZM19.2507 12.25H22.7507V22.75H19.2507V12.25ZM21.0007 3.5C11.3232 3.5 3.50067 11.375 3.50067 21C3.50067 25.6413 5.34442 30.0925 8.6263 33.3744C10.2513 34.9994 12.1805 36.2884 14.3037 37.1679C16.4269 38.0474 18.7025 38.5 21.0007 38.5C25.642 38.5 30.0932 36.6563 33.375 33.3744C36.6569 30.0925 38.5007 25.6413 38.5007 21C38.5007 18.7019 38.048 16.4262 37.1686 14.303C36.2891 12.1798 35.0001 10.2507 33.375 8.62563C31.75 7.00061 29.8208 5.71157 27.6976 4.83211C25.5744 3.95265 23.2988 3.5 21.0007 3.5ZM21.0007 35C17.2876 35 13.7267 33.525 11.1012 30.8995C8.47567 28.274 7.00067 24.713 7.00067 21C7.00067 17.287 8.47567 13.726 11.1012 11.1005C13.7267 8.475 17.2876 7 21.0007 7C24.7137 7 28.2747 8.475 30.9002 11.1005C33.5257 13.726 35.0007 17.287 35.0007 21C35.0007 24.713 33.5257 28.274 30.9002 30.8995C28.2747 33.525 24.7137 35 21.0007 35Z",
    fill: "#58486C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.9cd26cabd8bc4bae87656cd05ac8b470.svg";
export { ForwardRef as ReactComponent };